import * as types from "../../actions/ActionTypes";

const initialState = {
    loading: false,
    data: null,  // will hold the HTML string from backend
    error: null,
};

export const getTermsAndConditionsReducer = (state = initialState, action) => {
    switch (action.type) {
        case types.GET_TERMS_AND_CONDITIONS_START:
            return { ...state, loading: true, error: null };

        case types.GET_TERMS_AND_CONDITIONS_SUCCESS:
            return { ...state, loading: false, data: action.payload, error: null };

        case types.GET_TERMS_AND_CONDITIONS_ERROR:
            return { ...state, loading: false, error: action.payload };

        default:
            return state;
    }
};

export const getPrivacyPolicyReducer = (state = initialState, action) => {
    switch (action.type) {
        case types.GET_PRIVACY_POLICY_START:
            return { ...state, loading: true, error: null };

        case types.GET_PRIVACY_POLICY_SUCCESS:
            return { ...state, loading: false, data: action.payload, error: null };

        case types.GET_PRIVACY_POLICY_ERROR:
            return { ...state, loading: false, error: action.payload };

        default:
            return state;
    }
};

export const getCancellationRefundPolicyReducer = (state = initialState, action) => {
    switch (action.type) {
        case types.GET_CANCELLATION_REFUND_POLICY_START:
            return { ...state, loading: true, error: null };

        case types.GET_CANCELLATION_REFUND_POLICY_SUCCESS:
            return { ...state, loading: false, data: action.payload, error: null };

        case types.GET_CANCELLATION_REFUND_POLICY_ERROR:
            return { ...state, loading: false, error: action.payload };

        default:
            return state;
    }
};
